import type { TagVariant } from '@televet/kibble-ui/Tag';
import { z } from 'zod';

export const INSTANCE_STATUSES = ['Active', 'Paused', 'Completed', 'Archived'] as const;

export const INSTANCE_STATUS_TAG_VARIANT: Readonly<Record<string, TagVariant>> = {
  Active: 'success',
  Paused: 'warning',
  Completed: 'info',
  Archived: 'default',
} satisfies Record<(typeof INSTANCE_STATUSES)[number], TagVariant>;

export const SCHEDULE_TYPES = ['Cron', 'Once', 'Manual'] as const;

/**
 * `ownerType` is a free VarChar on the emitter, so these are the values in use
 * today rather than a database enum.
 */
export const OWNER_TYPES = ['Clinic', 'Platform'] as const;

export const instanceFiltersSchema = z.object({
  status: z.array(z.enum(INSTANCE_STATUSES)).optional().catch(undefined),
  templateId: z.array(z.string().min(1)).optional().catch(undefined),
  ownerType: z.array(z.string().min(1)).optional().catch(undefined),
  scheduleType: z.array(z.enum(SCHEDULE_TYPES)).optional().catch(undefined),
  search: z.string().min(1).optional().catch(undefined),
});

export type InstanceFilterValues = z.infer<typeof instanceFiltersSchema>;
